import React from 'react';
import { ButtonDropdown, ButtonDropdownProps } from '@amzn/awsui-components-core';

import constants from '../../common/constants';
import BrowserHistory from '../utils/BrowserHistory';
import RouterPaths from '../../common/RouterPaths';

const HeaderCollectionDropdown = () => {
  // TODO: add all collections route
  const dropDownItems = [
    { text: constants.ALL_COLLECTIONS, id: constants.ALL_COLLECTIONS },
    { text: constants.MY_COLLECTION_LABLE, id: constants.MY_COLLECTION_LABLE },
  ];

  const handleDropdownClick = (event: CustomEvent<ButtonDropdownProps.ItemClickDetails>) => {
    const eventId = event.detail.id;
    switch (eventId) {
      case constants.ALL_COLLECTIONS:
        BrowserHistory.push(RouterPaths.ALL_COLLECTION);
        break;
      case constants.MY_COLLECTION_LABLE:
        BrowserHistory.push(RouterPaths.MY_COLLECTION);
        break;
      default:
        break;
    }
  };

  return (
    <ButtonDropdown items={dropDownItems} onItemClick={handleDropdownClick}>
      {constants.COLLECTION_DROPDOWN_HEADER}
    </ButtonDropdown>
  );
};

export default HeaderCollectionDropdown;
